import styled from "styled-components";

import { device } from "utils/sizes";
import { colourScheme } from "utils/styling/colours";
import { Label as TypoLabel, Span } from "utils/styling/typography.styled";

export const StyledModal = styled.div`
    display: flex;
    flex-direction: column;
    overflow: auto;
    max-height: 95vh;
    height: 100%;
    width: 100%;
    max-width: 100vw;

    ${device.lg} {
        flex-direction: row;
        overflow: hidden;
        max-height: 90vh;
    }

    justify-content: space-between;
    gap: 1rem;
`;

export const ImageContainer = styled.div`
    flex: 3;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const StyledImage = styled.img`
    max-width: 100%;
    border-radius: 0.2rem;
    max-height: 100%;
`;

export const MetaDataSection = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    margin-right: 1rem;
    padding: 1rem;
`;

export const Label = styled(TypoLabel)`
    display: inline-flex;
    align-items: center;
    font-size: 1rem;
`;

export const DetailsContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    padding-bottom: 0.5rem;
    align-items: right;
    width: 100%;
`;

export const Detail = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-end;
    margin: 0;
    padding-left: 0.5rem 0;
`;

export const DetailLabel = styled(Span)`
    align-items: right;
    opacity: 0.75;
`;

export const DetailValue = styled(Span)`
    align-items: right;
    text-align: right;
`;

export const HorizontalRule = styled.hr`
    border: none;
    height: 0.05rem;
    background-color: ${colourScheme.fullWhite};
    margin: 1rem 0;
    width: 100%;
`;
